//
//
//


export default {

	props: {
		from: {
			type: Number,
			required: true
		},
    duration: {
			type: Number,
      default:1000
    },
		to: {
			type: Number,
			required: true
		}
	},
    data () {
      return {
        dFrom: 0,
        dTo:  0
      }
    },
    /*computed: {
      _from: function () {
        return this.from
      },
      _to: function () {
        return this.to
      },
    },*/
    mounted () {
        this.dTo  = this.to;
        this.dFrom = this.from;

    },
	methods: {

		Numberformatter: function (num) {
			if(!num)return 0;
      if(this.dTo%1 === 0){
			  num = Math.round(num);
        return num.toString().replace(/(\d)(?=(?:\d{3})+$)/g ,'$1 ');
      }else{
        return num.toFixed(2).replace(/(\d)(?=(?:\d{3})+$)/g ,'$1 ');
      }
			
		}
	},
    watch: {
        to:function(newVal , oldVal){
            this.dFrom = oldVal;
            this.dTo =  newVal;
            console.log(this.dFrom + '-' + this.dTo);
        },
    }
}
